import { useEffect, useState } from "react";

type WakeLockSentinel = {
  release: () => Promise<void>;
};

function isWakeLockSupported(): boolean {
  return "wakeLock" in navigator;
}

export function useWakeLock(active: boolean): { supported: boolean; active: boolean } {
  const [supported] = useState(isWakeLockSupported);
  const [held, setHeld] = useState(false);

  useEffect(() => {
    if (!active || !supported) {
      setHeld(false);
      return;
    }

    const wakeLock = (navigator as Navigator & { wakeLock: { request: (type: "screen") => Promise<WakeLockSentinel> } }).wakeLock;
    let lock: WakeLockSentinel | undefined;
    let cancelled = false;

    void wakeLock.request("screen").then((sentinel) => {
      if (cancelled) {
        void sentinel.release();
        return;
      }
      lock = sentinel;
      setHeld(true);
    }).catch(() => {
      setHeld(false);
    });

    return () => {
      cancelled = true;
      setHeld(false);
      if (lock !== undefined) {
        void lock.release();
      }
    };
  }, [active, supported]);

  return { supported, active: held };
}
